import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20flatlay%20with%20modern%20fashion%20accessories%20on%20light%20cream%20marble%20surface%2C%20soft%20natural%20daylight%2C%20elegant%20lifestyle%20aesthetic%2C%20editorial%20catalog%20photography%20with%20gentle%20shadows%2C%20neutral%20warm%20tones%2C%20scandinavian%20design%20vibe%2C%20white%20and%20beige%20palette%2C%20textured%20linen%20fabric%20in%20background%2C%20minimal%20composition%20with%20negative%20space&width=1600&height=900&seq=hero-yoybuy-autos-2026&orientation=landscape"
          alt="Yoybuy Sheet fashion shopping"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-2xl">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            {t('hero.title')}
          </h1>
          <p className="mt-4 md:mt-6 text-base md:text-lg text-white/85 max-w-lg leading-relaxed">
            {t('hero.subtitle')}
          </p>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row gap-3 md:gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm md:text-base font-semibold hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('hero.cta_sheet')}
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border-2 border-white/60 text-white text-sm md:text-base font-semibold hover:bg-white/15 hover:border-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('hero.cta_buy')}
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}